exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.clickable[data-v-5d403fe8] {\n  cursor: pointer;\n}\n.svg-videocam[data-v-5d403fe8] {\n  width: 30px;\n  height: 30px;\n  display: inline;\n  border: none !important;\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n", ""]);

